import moment from "moment";

export const formatThousand = (num) => {
  if (num === undefined || !num) {
    return;
  }
  if (num < 1000) {
    return `<1k`;
  } else if (num >= 1000 && num < 1000000) {
    return `${(num / 1000).toFixed(1)}K`;
  } else {
    return `${(num / 1000000).toFixed(1)}M`;
  }
};

export const formatDateString = (dateString, type) => {
  const date = moment(dateString);

  const formatHrs = () => {
    const now = moment();
    const diffInDays = now.diff(date, "days");
    const diffInYears = now.diff(date, "years");

    if (diffInYears < 0) {
      const absDiffInYears = Math.abs(diffInYears);
      return `${absDiffInYears} year${absDiffInYears > 1 ? "s" : ""} ago`;
    }
    if (diffInDays < 0) {
      const absDiffInDays = Math.abs(diffInDays);
      return `${absDiffInDays} day${absDiffInDays > 1 ? "s" : ""} ago`;
    }

    const diffInHours = now.diff(date, "hours");

    if (diffInHours < 0) {
      const absDiffInHours = Math.abs(diffInHours);
      return `${absDiffInHours} hour${absDiffInHours > 1 ? "s" : ""} ago`;
    }

    if (diffInYears >= 1) {
      return `${diffInYears} year${diffInYears > 1 ? "s" : ""}`;
    }
    if (diffInDays >= 1) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""}`;
    }

    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""}`;
  };

  const formatDate = () => {
    return date.format("ddd DD MMM");
  };

  if (type === "hrs") {
    return formatHrs();
  } else if (type === "date") {
    return formatDate();
  } else {
    return "Invalid type";
  }
};
